import { Button as e } from "@sprd/sprd-component-kit/v2";
import t from "clsx";
import { Fragment as n, jsx as r, jsxs as i } from "react/jsx-runtime";
//#region src/components/CountrySelector/base/CountrySelectorButton.tsx
function a({ country: a, onClick: o, "aria-label": s, className: c }) {
	return /* @__PURE__ */ i(e, {
		variant: "ghost",
		size: "m",
		className: t("px-6", c),
		"aria-label": s,
		onClick: o,
		startIcon: /* @__PURE__ */ r("span", {
			"aria-hidden": "true",
			className: "flex size-6 shrink-0 items-center justify-center [&>svg]:w-full",
			children: a.flag
		}),
		children: [a.label, a.description ? /* @__PURE__ */ i(n, { children: [" ", a.description] }) : null]
	});
}
//#endregion
export { a as CountrySelectorButton };
